import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bridge" }
const _hoisted_2 = { class: "absolute top-0 w-full flex justify-end py-5 px-8" }
const _hoisted_3 = { class: "drawer py-5 px-8" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Next ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bg_blur = _resolveComponent("bg-blur")!
  const _component_transfer_steps = _resolveComponent("transfer-steps")!
  const _component_transfer_amount = _resolveComponent("transfer-amount")!
  const _component_transfer_inputs = _resolveComponent("transfer-inputs")!
  const _component_nomad_button = _resolveComponent("nomad-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" BRIDGE TOKENS card "),
    _createElementVNode("div", null, [
      _createCommentVNode(" color blur section "),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_bg_blur, { class: "absolute inset-0 w-full h-full z-negative" }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_transfer_steps, { current: 1 })
        ]),
        _createVNode(_component_transfer_amount)
      ]),
      _createCommentVNode(" bottom drawer "),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_transfer_inputs, { class: "bridge-inputs" }),
        _createVNode(_component_nomad_button, {
          class: "w-full uppercase mt-6 bg-white text-black h-11 flex justify-center",
          onClick: _ctx.next
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"])
      ])
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}